import React, { PropsWithChildren } from 'react';
import { FlagProvider } from '@unleash/proxy-client-react';
import { unleashClient } from './const';

//How to use it
//import { useFlag } from '@unleash/proxy-client-react';
//const isEnabled = useFlag('featureName'); - inside hook or component

const UnleashProvider = ({ children }: PropsWithChildren) => {
  if (!process.env.UNLEASH_CLIENT_KEY || !process.env.UNLEASH_URL) {
    return children as React.ReactElement;
  }

  return (
    <FlagProvider unleashClient={unleashClient} startClient={false}>
      {children}
    </FlagProvider>
  );
};

export default UnleashProvider;